import { DeviceType } from '../context/chat-widget-context/types';

export const getDeviceType = (width: number): DeviceType => {
  if (width <= 768) return DeviceType.MOBILE;
  if (width <= 1024) return DeviceType.TABLET;
  return DeviceType.DESKTOP;
};
